import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container max-w-2xl px-4 mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "font-medium text-left" }, " If you are feeling unwell please refer to your information pack for guidance. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "font-medium text-left" }, "For all emergencies call 999.", -1)
const _hoisted_4 = { class: "container max-w-2xl mx-auto" }
const _hoisted_5 = { class: "px-4 py-6" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Log Out ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_PageTitle, { title: "Account" }),
            _hoisted_2,
            _hoisted_3
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ion_button, {
                id: "logout-button",
                expand: "block",
                fill: "outline",
                onClick: _withModifiers(_ctx.logout, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}